import Chat from './Chat';

const Hero = () => {
  return (
    <section className='min-h-screen flex flex-col items-center justify-start relative overflow-hidden bg-black'>
      {/* Galaxy background with stars */}
      <div className='absolute inset-0'>
        {/* Deep space gradient */}
        <div className='absolute inset-0 bg-gradient-to-b from-black via-gray-950 to-black'></div>
        
        {/* Nebula effects */}
        <div className='absolute top-1/4 left-1/4 w-96 h-96 bg-white/[0.02] rounded-full blur-3xl animate-pulse' style={{ animationDuration: '8s' }}></div>
        <div className='absolute bottom-1/3 right-1/4 w-80 h-80 bg-white/[0.015] rounded-full blur-3xl animate-pulse' style={{ animationDuration: '12s', animationDelay: '2s' }}></div>
        
        {/* Floating stars layer 1 - small */}
        <div className='absolute inset-0'>
          {[...Array(60)].map((_, i) => (
            <div
              key={`star-s-${i}`}
              className='absolute w-[1px] h-[1px] bg-white rounded-full animate-pulse'
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDuration: `${2 + Math.random() * 3}s`,
                animationDelay: `${Math.random() * 2}s`,
                opacity: 0.3 + Math.random() * 0.4,
              }}
            />
          ))}
        </div>
        
        {/* Floating stars layer 2 - medium */}
        <div className='absolute inset-0'>
          {[...Array(30)].map((_, i) => (
            <div
              key={`star-m-${i}`}
              className='absolute w-[2px] h-[2px] bg-white rounded-full'
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `float-star ${8 + Math.random() * 8}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 5}s`,
                opacity: 0.4 + Math.random() * 0.4,
              }}
            />
          ))}
        </div>
        
        {/* Floating stars layer 3 - bright */}
        <div className='absolute inset-0'>
          {[...Array(15)].map((_, i) => (
            <div
              key={`star-b-${i}`}
              className='absolute w-[3px] h-[3px] bg-white rounded-full'
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `float-star ${10 + Math.random() * 10}s ease-in-out infinite, twinkle ${2 + Math.random() * 2}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 3}s`,
                boxShadow: '0 0 6px 1px rgba(255,255,255,0.3)',
              }}
            />
          ))}
        </div>
      </div>

      {/* Star animation keyframes */}
      <style>{`
        @keyframes float-star {
          0%, 100% { transform: translate(0, 0); }
          25% { transform: translate(10px, -15px); }
          50% { transform: translate(-5px, 10px); }
          75% { transform: translate(-15px, -5px); }
        }
        @keyframes twinkle {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>

      <div className='container mx-auto px-6 py-8 relative z-10 flex flex-col items-center justify-start min-h-screen'>
        {/* Main headline */}
        <div className='text-center max-w-4xl mx-auto space-y-4 pt-16'>
          <p className='text-xs tracking-[0.3em] text-gray-500 uppercase font-medium'>
            Live Entertainment Platform
          </p>
          <h1 className='text-5xl lg:text-7xl font-bold text-white tracking-tight leading-none'>
            METRO CITY
            <span className='block text-transparent bg-clip-text bg-gradient-to-r from-gray-300 via-white to-gray-300'>
              GROOVE
            </span>
          </h1>

          <p className='text-lg lg:text-xl text-gray-400 max-w-2xl mx-auto font-light'>
            Discover and connect with live entertainment worldwide. Your AI-powered guide to events, venues, and experiences.
          </p>
        </div>

        {/* AI Chat Interface */}
        <div className='flex-1 w-full max-w-3xl mx-auto flex flex-col mt-8'>
          <Chat />
        </div>
      </div>
    </section>
  );
};

export default Hero;
